import { WebPlugin } from '@capacitor/core';
import Rbird from 'releasebird-javascript-sdk';
export class ReleasebirdWeb extends WebPlugin {
    async showWidget() {
        Rbird.showWidget();
    }
    async logout() {
        // Rbird.logout();
    }
    async showButton(options) {
        Rbird.showButton(options.showButton);
    }
    async echo(options) {
        console.log('ECHO', options);
        return options;
    }
    async initialize(options) {
        if (options.showButton != null) {
            Rbird.initialize(options.apiKey, options.showButton);
        }
        else {
            Rbird.initialize(options.apiKey);
        }
    }
    async identify(options) {
        Rbird.identify(options.hash, options.identify);
    }
}
//# sourceMappingURL=web.js.map